import { ReactElement, useState, useEffect } from 'react';
import { getLabelFallback, getLoggedUserMail } from '@utils/utils';

import { useSelector } from 'react-redux';

import PageTitle from '@components/PageTitle';
import LoginBanner from '@components/LoginBanner';
import DeliveryAddressForm from '@components/DeliveryAddressForm';
import SimpleElementSkeleton from './skeletons/SimpleElementSkeleton';
import PayPalButton from '@components/PayPalButton';

import BossDeliveryAddressForm from '@components/BossDeliveryAddressForm';

type ShippingStepProps = {
    onSubmitAddress: (value) => void,
    addressErrors: string;
    onSubmitBossAddress: (value) => void,
}

const ShippingStep = (props: ShippingStepProps) : ReactElement => {
    
    const {
        onSubmitAddress,
        addressErrors,
        onSubmitBossAddress
    } = props;

    const cart = useSelector(state => state.cart.cart);
    const isMobile = useSelector(state => state.cart.isMobile);
    const config = useSelector(state => state.cart.config);

    const [buyerName, setBuyerName] = useState(null);
    const [isBoss, setIsBoss] = useState(false);

    useEffect(() => {
        if(!!cart) {
            setBuyerName(getLoggedUserMail(cart.buyerDistinguishedName));
            if (!!cart.orderItem && !!cart.orderItem[0] && !!cart.orderItem[0].xitem_storeIdentifier) {
                setIsBoss(cart.orderItem[0].xitem_storeIdentifier);
            }
        }
    }, [cart]);

    return(
        <div className="shipping-step">
            <PageTitle label={ isBoss ? getLabelFallback('SHIPPING_BOSS_PAGE_TITLE') : getLabelFallback('SHIPPING_PAGE_TITLE') } />
            <div className="shipping-step-skip">
                    { getLabelFallback('SKIP_THIS_STEP_LABEL') }
            </div> 
            <div className="shipping-step-paypal">             
                <PayPalButton onApproveUrl={config.paypal.PAYPAL_EXPRESS_CHECKOUT_URL} onReturnUrl={config.paypal.PAYPAL_RETURN_URL_CART} smartGlassesError={''}/>
            </div>
            {
                isBoss ? 
                  <div className="shipping-step-boss">
                    { getLabelFallback('SHIPPING_BOSS_PAGE_SUBTITLE') }
                  </div>
                : !!cart ? !buyerName &&  
                    <LoginBanner /> :
                    <div style={{marginTop: '24px'}}>
                        <SimpleElementSkeleton width={!isMobile ? '343px' : '100%'} height={'48px'} />
                    </div>

            }
            <div className="shipping-step-content">
                {
                    isBoss ? 
                      <BossDeliveryAddressForm onSubmit={(data) => onSubmitBossAddress(data)} addressErrors={addressErrors}/>  
                    : <DeliveryAddressForm onSubmitAddress={(data) => onSubmitAddress(data)} buyerName={buyerName} addressErrors={addressErrors}/>
                }
            </div>
        </div>
    )
}

export default ShippingStep;